import React from "react";
import { Megaphone, AlertCircle } from "lucide-react";

const PRIORITY_STYLES = {
  high: { bg: "bg-red-50", border: "border-red-200", text: "text-red-700", tag: "Urgent" },
  medium: { bg: "bg-gold/10", border: "border-gold/40", text: "text-gold-dark", tag: "Important" },
  low: { bg: "bg-slate-50", border: "border-slate-200", text: "text-slate-600", tag: "Info" },
};

export default function AnnouncementsSection({ announcements = [] }) {
  const active = announcements.filter((a) => a.is_active);
  if (active.length === 0) return null;

  return (
    <section className="py-16 bg-[#F1F5F9]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-full bg-deepblue-900 text-gold flex items-center justify-center">
            <Megaphone className="w-5 h-5" />
          </div>
          <div>
            <div className="text-gold-dark text-xs tracking-[0.3em] uppercase">Annonces</div>
            <h2 className="font-serif text-2xl text-deepblue-900">Dernières nouvelles</h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="announcements-grid">
          {active.map((a) => {
            const s = PRIORITY_STYLES[a.priority] || PRIORITY_STYLES.medium;
            return (
              <div key={a.id} className={`rounded-2xl p-6 border ${s.bg} ${s.border} card-lift`} data-testid={`announcement-${a.id}`}>
                <div className={`inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest ${s.text} mb-3`}>
                  <AlertCircle className="w-3 h-3" /> {s.tag}
                </div>
                <h3 className="font-serif text-xl text-deepblue-900 leading-snug">{a.title}</h3>
                <p className="mt-3 text-slate-600 text-sm leading-relaxed">{a.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
